<template>
    <div class="papsi-wrapper flex justify-between">
        <div class="flex max-sm:flex-col max-sm:gap-3 justify-between w-full">
            <div>
                <h1 class="text-xl font-semibold text-[#24723b]" v-text="'Official Business Request'"/>
                <p class="text-xs text-[#747474] mt-2" v-text="'Home / Form Requests / Official Business Request'"/>
            </div>
            <div class="flex gap-3">
                <ButtonComponent 
                    class="w-[200px]"
                    :enabled="button"
                    :name="'REQUEST STATUS'"
                    @click="obRequest"
                />
                <ButtonComponent 
                    class="w-[200px]"
                    :enabled="!button"
                    :name="'NOTED REQUEST'"
                    @click="notedRequest"
                />
            </div>
        </div>
    </div>
    <div class="mt-6 w-full h-full flex flex-col gap-3">
        <div class="flex gap-3">
            <TextboxComponent 
                v-if="button"
                v-model="search"
                @input="searchByName()" 
                :labelname="'Search'" 
                class="w-[500px]"/>
            <ComboBoxComponent
                v-if="button"
                v-model="filter" 
                :labelname="'Filter'" 
                class="w-[250px]" 
                :data="combobox"
                @change="searchByName()"/>
        </div>
        
        <div class="h-[73vh]">
            <TableComponent 
                :header="header_name" 
                :column="column_name" 
                :data="ob_filter" 
                :viewBtn="true"
                :select="false"
                @clickView="openObModal" />
        </div>
    </div>
    <!-- PROMPT SUCCESSS ERROR -->
    <PromptComponent v-if="promptModal"
        :header="header"
        :header1="header1"
        :success="promptSuccess"
        @close="promptModal = false"/>

    <!-- VALIDATION PROMPT -->
    <ValidationComponent v-if="validation"
        :header="headerPrompt"
        @yes="yesValidation"
        @no="noValidation"/>

    <!-- MODAL -->
    <OfficialBusinessModal v-if="obmodal"
        :data="modal_data"
        :cancel="false"
        :apv="false"
        :noted="true"
        @close="obmodal = false"
        @notedRequest="noteRequest"/>

</template>
<script>
    import { defineComponent } from "vue";
    import Ob from "@/services/officialbusiness";
    import TextboxComponent from "@/v1/components/TextBoxComponent/TextboxComponent.vue";
    import TableComponent from "@/v1/components/TableComponent/TableComponent.vue";
    import PromptComponent from "@/v1/components/PromptComponents/PromptComponent.vue";
    import ValidationComponent from "@/v1/components/PromptComponents/ValidationComponent.vue";
    import ButtonComponent from "@/v1/components/ButtonComponent/ButtonComponent.vue";
    import ComboBoxComponent from "@/v1/components/ComboBoxComponent/ComboBoxComponent.vue";
    import OfficialBusinessModal from "@/v1/modal/OfficialBusinessModal.vue";
    export default defineComponent({
    components: {
        PromptComponent,
        ValidationComponent,
        TableComponent,
        ButtonComponent,
        ComboBoxComponent,
        TextboxComponent,
        OfficialBusinessModal
    },
    data() {
        return {
            combobox:[
                { key: "ALL", value: "ALL" },
                { key: "APPROVED", value: "APPROVED" },
                { key: "FOR APPROVAL", value: "FOR APPROVAL" },
                { key: "DISAPPROVED", value: "DISAPPROVED" },
                { key: "CANCELLED", value: "CANCELLED" },
            ],
            header_name:  [
                "Reference No.",
                "Employee Name",
                "Location",
                "Purpose" ,
                "Status",
                "Action",
            ],
            column_name:  [ 
                "ref_no",
                "employee_name",
                "location",
                "purpose",
                "status",
                "action"
            ],
            button: true,
            ob_data:[],
            ob_filter:[],
            search: '',
            filter: "ALL",
            obmodal:false,
            modal_data: null,
            promptModal: false,
            header:null,
            header1:null,
            promptSuccess:true,
            
        }
    },
    mounted(){
        this.getData();
    },
    methods:{
        obRequest(){
            this.button = true
            this.getData()
        },
        notedRequest(){
             this.button = false
            this.filterNotedRequest()
        },
        filterNotedRequest(){
            this.ob_filter = this.ob_data.filter(e =>e.employee_name.toLowerCase().includes(this.search.toLowerCase()) && e.status === "APPROVED" && e.noted_emp_key != null)
        },
        triggerbtn(){
            this.button = !this.button ? true : false
        },
        async getData(){
            this.$emit("showLoader")
            let that = this
            await Ob.getRequest().then(function(response){
                that.ob_data = response.data.data
                that.ob_filter = response.data.data
                that.searchByName();
            })
            this.$emit("hideLoader")
        },
        searchByName(){
            if(this.button){
                 if(this.filter == "ALL")
                this.ob_filter = this.search ? this.ob_data.filter(e =>e.employee_name.toLowerCase().includes(this.search.toLowerCase()) && e.noted_emp_key === null) : this.ob_data.filter(e => e.noted_emp_key === null)
            else
                this.ob_filter =  this.filter? this.ob_data.filter(e =>e.employee_name.toLowerCase().includes(this.search.toLowerCase()) && e.status === this.filter && e.noted_emp_key === null) : this.ob_data.filter(e => e.noted_emp_key === null)
            }
        },
        openObModal(data){
            this.modal_data = data
            this.obmodal = true
        },
        async noteRequest(ref_no){
            this.$emit("showLoader")
            let that = this
            await Ob.notedRequest(ref_no).then(function(){
                that.obmodal            = false
                that.promptSuccess      = true
                that.header             = "NOTED REQUEST"
                that.header1            = "Your Official Business request has been noted."
                that.promptModal        = true
                that.updateRequest(ref_no)
            })
            this.$emit("hideLoader")
        },
        updateRequest(ref_no)
        {
            const record = this.ob_data.find(e => e.ref_no === ref_no);
            if (record) {
                record.noted_date = new Date().toISOString();
                record.noted_emp_key = this.$store.state.employee_key;
                this.searchByName();
            }
            
        }
    }
})

</script>

